import Service from '@ember/service';

/**
 * Service to manage inline callbacks by element id.
 * Useful when the Ember APIs are not an option.
 */
class ElementCallbackService extends Service {
  #elementIdToCallbackMap = new Map();

  get callbacks() {
    return this.#elementIdToCallbackMap;
  }

  addCallback(elementId, callback) {
    this.callbacks.set(elementId, callback);
  }

  removeCallback(elementId) {
    this.callbacks.delete(elementId);
  }
}

export default ElementCallbackService;
